import { Box, ButtonBase, CircularProgress, InputBase, Skeleton, ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material';
import cx from 'classnames';
import { SettingsOutlined } from "@mui/icons-material";
import { calculateDaysBetween, chartDateOptions, chartDateTimeFrames, chartTypes, normalizeFrame, pivotTableCategoryOptions, rhChartColorsDark, rhChartColorsLight } from '../chartFilterEnums';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../../../theme';
import { useEffect, useMemo, useRef, useState } from 'react';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import ShDateRangePicker from '../../../theme/ShDateRangePicker';
import { useReportHubFilters } from '../ReportHubFilterContext';
import { AreaChartContentReports } from '../../../theme/charts/AreaChart';
import { RHBarChart } from '../charts/RHBarChart';
import { LineChartContentReports } from '../../../theme/charts/LineChart';
import { ReportDetailsPageDetails } from './ReportDetailsPageDetails';
import { MRhSettings } from './MRhSettings';
import { RhTimeframeDropDown } from './RhTimeframe';
import { RhDateSelector } from './RhDateSelector';
import { RhSubtypeToggle } from './RhSubtypeToggle';
import Text from '../../../theme/text/Text';
import { getReportForEnvironment, getReportKey } from '../reports';
import NumberInput from '../../../theme/inputs/NumberInput';
import { MRhFilter } from './MRhFilter';
import { RhFilter } from './RhFilter';
import EditIcon from '@mui/icons-material/Edit';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Heading from '../../../theme/text/Heading';
import { ErrorBoundary } from 'react-error-boundary';
import { RhPivotTableColumn } from './pivottable/RhPivotTableColumn';
import { RhHeatmapToggle } from './pivottable/RhHeatmapToggle';
import { RhPivotModeToggle } from './pivottable/RhPivotModeToggle';
import { RhPivotSettings } from './RhPivotSettings';
import { getPivotView, pivotSettings } from '../reportUtils';
export const RhPivotHeader = (props) => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const filtersRegistry = useReportHubFilters();

    const chartOption = getReportForEnvironment(getReportKey(props.currentReport), filtersRegistry.environment);

    const pivotView = getPivotView(props.currentReport);
    const pivotHidden = chartOption?.pivotHidden || props.currentReport?.pivotHidden || [];
    const showModeToggle = !pivotHidden.includes(pivotSettings.MODE) && !pivotHidden.includes(pivotSettings.SETTINGS);
    const setPivotMode = (mode) => {
        props.setCurrentReport(prev => ({ ...prev, pivot: { ...prev?.pivot, mode } }));
    };

    const categorySettings = useMemo(() => {
        return filtersRegistry?.chartSettings?.categorySettings?.();
    }, [filtersRegistry]);

    const [edittingName,setEdittingName] = useState(false);
    useEffect(() => {
        setEdittingName(props.defaultNameEdit);
    },[props.defaultNameEdit])

    const [anchorEl, setAnchorEl] = useState(null);
    const popoverOpen = Boolean(anchorEl);
    const popoverId = popoverOpen ? 'popover' : undefined;
    
    const handlePopoverClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const [rhFilterModalOpen, setRhFilterModalOpen] = useState(false);
    const rhFilterModal = {
        open: rhFilterModalOpen,
        setOpen: setRhFilterModalOpen
    }

    const handleRhFilterClose = () => {
        setRhFilterModalOpen(false);
    };



    const [rhSettingsModalOpen, setRhSettingsModalOpen] = useState(false);
    const rhSettingsModal = {
        open: rhSettingsModalOpen,
        setOpen: setRhSettingsModalOpen
    }

    const handleRhSettingsClose = () => {
        setRhSettingsModalOpen(false);
    };



    return (
        <Box 
            className={cx(undefined, {
                'mobile-line':props.currentReport?.displayType === chartTypes.LINE || props.currentReport?.displayType === chartTypes.AREA,
            })}
            sx={{
                mt:2,
                width:1,
                display:'flex',
                justifyContent:"space-between",
                alignItems:'center',
                paddingX:4,
                pr:1,
                "@media screen and (max-width: 63.9735em)" :{
                    flexDirection:'column',
                    alignItems:'flex-start',
                    gap:0,
                },
                "@media screen and (max-width: 47.9735em)" :{
                    px:3,
                    "&.mobile-line": {
                        pr:0,
                    }
                },
                '@media screen and (max-width: 34.375em)': {
                    mt:0,
                    gap:3,
                },
            }}
        >
            <Box
                sx={{
                    display:"none",
                    position:'fixed',
                    top:"72px",
                    width:1,
                    left:"0px",
                    pl:2,
                    background:colors.bg["tertiary"],
                    zIndex:100,
                    pb:2,
                    "@media screen and (max-width: 47.9735em)" :{
                        display:"flex",
                        alignItems:'center',
                        zIndex:999,
                    },
                }}
            >
                <Box
                    sx={{
                        flex:1,
                        display:"flex",
                        alignItems:'center',
                    }}
                >
                    {edittingName?
                        <Box
                            className={cx(undefined, {
                                'is-error':props.nameError,
                            })}
                            sx={{
                                display:'flex',
                                alignItems:"center",
                                px:0.5,
                                height:32,
                                borderRadius:12,
                                minWidth:450,
                                background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[200],
                                "@media screen and (max-width: 768px)" : {
                                    minWidth:"unset",
                                    width:1,
                                },
                                "&.is-error" : {
                                    background:colors.red[100],
                                    borderColor:colors.red[400],
                                }
                            }}
                        >
                            <Box
                                className={cx(undefined, {
                                    'is-error':props.nameError,
                                })}
                                sx={{
                                    background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0],
                                    border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                    boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                                    height:24,
                                    borderRadius:4,
                                    px:2,
                                    lineHeight:"24px",
                                    "&.is-error": {
                                        background:colors.red[400],
                                    }
                                }}
                            >
                                <Text
                                    color={props.nameError && (theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt['light'])}
                                >
                                    {t("name")}
                                </Text>
                            </Box>
                            <InputBase 
                                value={props.currentReport?.name}
                                onChange={(e) => {
                                    props.setNameError(false);
                                    props.setCurrentReport(prev => ({
                                        ...prev,
                                        name:e.target.value,
                                    }))
                                }}
                                name='report_name'
                                placeholder={t("report_name")}
                                sx={{
                                    flex:1,
                                    height:1,
                                    width:'auto',
                                    fontSize:14,
                                    px:2,
                                    // py:1,
                                    fontWeight:1000,
                                    fontFamily:"Roboto, sans-serif",
                                    color:colors.txt["primary"],
                                }}
                            />
                        </Box>
                    :
                        <Heading >
                            {props.currentReport?.name}
                        </Heading>
                    }
                    {!props.defaultNameEdit && (
                        <ButtonBase
                            onClick={() => {
                                setEdittingName(prev => !prev);
                            }}
                            sx={{
                                flexShrink:0,
                                ml:2,
                                height:32,
                                // width:32,
                                // background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[400],
                                borderRadius:4,
                                color:theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.txt['secondary'],
                            }}
                        >
                            {edittingName ? <EditIcon/> : <EditOutlinedIcon />}
                        </ButtonBase>
                    )}
                </Box>
                {/* <Box
                    sx={{
                        background:theme.palette.mode === 'dark' ? colors.grey[500] : colors.grey[400],
                        borderTopLeftRadius:16,
                        borderBottomLeftRadius:16,
                        display:"flex",
                        ml:2,
                        height:32,
                    }}
                >
                    <ButtonBase
                        onClick={()=> {
                            rhSettingsModal.setOpen(true);
                        }}
                        sx={{
                            px:2,
                            borderTopLeftRadius:16,
                            borderBottomLeftRadius:16,
                            color:theme.palette.mode === "dark" ? colors.txt["primary"] : colors.txt["light"],
                        }}
                    >
                        <SettingsOutlined fontSize="small"/>
                    </ButtonBase>
                    <ButtonBase
                        onClick={()=> {
                            rhFilterModal.setOpen(true);
                        }}
                        sx={{
                            px:2,
                            borderTopLeftRadius:16,
                            borderBottomLeftRadius:16,
                            background:theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                            color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                        }}
                    >
                        <FilterAltOutlinedIcon fontSize="small"/>
                    </ButtonBase>
                </Box> */}
                
            </Box>

            <Box
                sx={{
                    width:1,
                    "@media screen and (max-width: 63.9735em)" :{
                        mb:4,
                    },
                    "@media screen and (max-width: 47.9735em)" :{
                        mt:7,
                    },
                    '@media screen and (max-width: 34.375em)': {
                        mb:0,
                    },

                }}
            >
                <Box
                    sx={{
                        display:"flex",
                        width:1,
                        justifyContent:'space-between',
                        // alignItems:''
                        pr:3,
                        "@media screen and (max-width: 768px)" : {
                            display:'none',
                        }
                    }}
                >
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:'center',
                            gap:1,
                            minWidth:400,
                            "@media screen and (max-width: 768px)" : {
                                display:'none'
                            }
                        }}
                    >
                        
                        {edittingName?
                            <Box
                                className={cx(undefined, {
                                    'is-error':props.nameError,
                                })}
                                sx={{
                                    display:'flex',
                                    alignItems:"center",
                                    px:0.5,
                                    height:40,
                                    borderRadius:12,
                                    minWidth:450,
                                    border:`1px solid ${theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[200]}`,
                                    background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[200],
                                    "@media screen and (max-width: 768px)" : {
                                        minWidth:"unset",
                                        width:1,
                                    },
                                    "&.is-error" : {
                                        background:colors.red[100],
                                        borderColor:colors.red[400],
                                    }
                                }}
                            >
                                <Box
                                    className={cx(undefined, {
                                        'is-error':props.nameError,
                                    })}
                                    sx={{
                                        background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[0],
                                        border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
                                        height:32,
                                        borderRadius:4,
                                        px:2,
                                        lineHeight:"32px",

                                        "&.is-error": {
                                            background:colors.red[400],
                                        }
                                    }}
                                >
                                    <Text
                                        color={props.nameError && (theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt['light'])}
                                    >
                                        {t("name")}
                                    </Text>
                                </Box>
                                <InputBase 
                                    value={props.currentReport?.name}
                                    onChange={(e) => {
                                        props.setNameError(false);
                                        props.setCurrentReport(prev => ({
                                            ...prev,
                                            name:e.target.value,
                                        }))
                                    }}
                                    name='report_name'
                                    placeholder={t("report_name")}
                                    sx={{
                                        flex:1,
                                        height:1,
                                        width:'auto',
                                        fontSize:21,
                                        px:2,
                                        // py:1,
                                        fontWeight:1000,
                                        fontFamily:"Roboto, sans-serif",
                                        color:colors.txt["primary"],
                                    }}
                                />
                            </Box>
                        :
                            <Heading>
                                {props.currentReport?.name}
                            </Heading>
                        }
                        {!props.defaultNameEdit && (
                            <ButtonBase
                                onClick={() => {
                                    setEdittingName(prev => !prev);
                                }}
                                sx={{
                                    height:40,
                                    width:40,
                                    // background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[200],
                                    color:theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.txt['secondary'],
                                    borderRadius:4,
                                }}
                            >
                                {edittingName ? <EditIcon/> : <EditOutlinedIcon />}
                            </ButtonBase>
                        )}

                    </Box>

                    {showModeToggle && (
                        <Box sx={{ display: 'flex', alignItems: 'center',gap:1, }}>
                            <RhPivotModeToggle mode={pivotView.mode} onChange={setPivotMode} />
                            <RhPivotSettings
                                currentReport={props.currentReport}
                                setCurrentReport={props.setCurrentReport}
                                chartOption={chartOption}
                            />
                        </Box>
                    )}

                </Box>

                <Box
                    sx={{
                        width:1,
                        // background:'#fff',
                        // height:32,
                        display:"flex",
                        justifyContent:"space-between",
                        mb:4,
                        mt:1,
                        pr:3,
                        "@media screen and (max-width: 768px)" : {
                            display:'none',
                        }
                    }}
                >
                    <RhFilter
                        
                        currentReport={props.currentReport}
                        setCurrentReport={props.setCurrentReport}
                    />
                    <Box>
                        <RhDateSelector
                            currentReport={props.currentReport}
                            setCurrentReport={props.setCurrentReport}
                        />
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <RhSubtypeToggle
                            currentReport={props.currentReport}
                            setCurrentReport={props.setCurrentReport}
                        />
                        <Box
                            sx={{
                                minWidth:300,
                            }}
                        >
                            <ToggleButtonGroup
                                value={props.currentReport?.table.column.type}
                            exclusive
                            
                            onChange={(e, newType) => {
                                if (!newType) return;

                                props.setCurrentReport(prev => {
                                    if(newType === pivotTableCategoryOptions.COLUMN) {
                                        return {
                                            ...prev,
                                            table: {
                                                row:prev.table.row,
                                                column: {
                                                    type: pivotTableCategoryOptions.COLUMN,
                                                    key:null,
                                                    values:null,
                                                }
                                            }
                                        }
                                    }
                                    if(newType === pivotTableCategoryOptions.DATERANGE) {
                                        return {
                                            ...prev,
                                            table: {
                                                row:prev.table.row,
                                                column: {
                                                    type: pivotTableCategoryOptions.DATERANGE,
                                                }
                                            }
                                        }

                                    }
                                    throw new Error("Unrecognized pivot table type");
                                });
                            }}

                            aria-label="Active"

                            // className={cx(`${currentReport.table.column.type}`, {
                            //     'active': currentReport.date.type == chartDateOptions.RELATIVE 
                            // })}
                            sx={{
                                width:1,
                                background:colors.grey[200],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                // "&.active" : {
                                //     background: colors.grey[100],
                                //     transition:"250ms",
                                // },
                                }}
                            >
                                <ToggleButton
                                    sx={{
                                        flex:1,
                                        padding: 0,
                                        paddingX: 2,
                                        border: 0,
                                        lineHeight: "32px",
                                        textTransform: "unset",
                                        borderRadius: "32px !important",
                                        color: theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400], 
                                        transition: "250ms",
                                        "&.Mui-selected": {
                                            background: colors.grey[400], 
                                            color: "#fff", 
                                            fontWeight:"bold",
                                        },
                                        "&.Mui-selected:hover": {
                                            background:theme.palette.mode === "dark" ? colors.grey[600]: "#1F293D",
                                        },
                                    }}
                                    value={pivotTableCategoryOptions.DATERANGE}
                                >
                                    <span
                                        style={{
                                            flexShrink:0,
                                        }}
                                    >
                                    {t('date_range')} 
                                    </span>
                                </ToggleButton>
                                <ToggleButton
                                    sx={{
                                        flex:3,
                                        padding: 0,
                                        paddingX: 2,
                                        border: 0,
                                        lineHeight: "32px",
                                        textTransform: "unset",
                                        borderRadius: "32px !important",
                                        color: theme.palette.mode === "dark" ? colors.txt["secondary"] : colors.grey[400], 
                                        // background: currentReport.category.use ? colors.grey[400] : "transparent", 
                                        transition: "250ms",
                                        "&.Mui-selected": {
                                            background: colors.grey[400], 
                                            color: theme.palette.mode === "dark" ? colors.txt["primary"] :  colors.txt["white"], 
                                            fontWeight:"bold",
                                            pr:0.5,
                                            display:'flex',
                                            alignItems:'center',
                                            gap:1.5,
                                            "@media screen and (max-width: 47.9375em)" : {
                                                justifyContent:'center',
                                            }
                                        },
                                        
                                        "&.Mui-selected:hover": {
                                            background:theme.palette.mode === "dark" ? colors.grey[600]: "#1F293D",
                                        },
                                    }}
                                    value={pivotTableCategoryOptions.COLUMN}
                                >
                                    {t('column')}

                                    {props.currentReport.table.column.type === pivotTableCategoryOptions.COLUMN  &&
                                        <Box
                                            sx={{
                                                flex:1,
                                                "@media screen and (max-width: 47.9375em)" : {
                                                    display:"none",
                                                }
                                            }}
                                        >
                                            <RhPivotTableColumn
                                                key={props.currentReport.table.row + " " + props.currentReport.table.column.key}
                                                chartOption={chartOption}
                                                setCurrentReport={props.setCurrentReport}
                                                currentReport={props.currentReport}
                                            />
                                        </Box>
                                    }
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Box>
                    </Box>
                </Box>

            </Box>
            <ReportDetailsPageDetails
                chartOption={chartOption}
                currentReport={props.currentReport}
                filtersRegistry={filtersRegistry}
                setCurrentReport={props.setCurrentReport}
                id={popoverId}
                open={popoverOpen}
                anchorEl={anchorEl}
                onClose={handleClose}
                stopPropagation={true}
            />
            <MRhFilter
                onOpen={() => rhFilterModal.setOpen(true)} 
                onClose={() => rhFilterModal.setOpen(false)} 
                open={rhFilterModal.open} 
                handleClose={handleRhFilterClose} 

                currentReport={props.currentReport}
                setCurrentReport={props.setCurrentReport}
            />

            <MRhSettings
                onOpen={() => rhSettingsModal.setOpen(true)} 
                onClose={() => rhSettingsModal.setOpen(false)} 
                open={rhSettingsModal.open} 
                handleClose={handleRhSettingsClose} 

                currentReport={props.currentReport}
                setCurrentReport={props.setCurrentReport}
                filtersRegistry={filtersRegistry}
                chartOption={chartOption}
            />
        </Box>
    )
}